import { Label } from "@/components/ui/label";

export const Field = ({ label, hint, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="eyebrow block">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-neutral-400">{hint}</p>}
  </div>
);

export const NativeSelect = ({ value, onChange, children, testid, className = "" }) => (
  <select
    data-testid={testid}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className={`h-10 w-full border border-input bg-[#18181B] text-[#F4F1EA] px-3 text-sm focus:outline-none focus:ring-1 focus:ring-[#C5A059] ${className}`}
  >
    {children}
  </select>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`press inline-flex items-center justify-center gap-2 h-10 px-5 rounded-full bg-[#C5A059] text-[#0A0A0C] text-sm font-semibold hover:bg-[#D9B872] hover:shadow-[0_0_24px_rgba(197,160,89,0.35)] disabled:opacity-40 disabled:pointer-events-none ${className}`}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`press inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full border border-white/10 bg-white/[0.03] text-sm text-[#F4F1EA] hover:border-[#C5A059]/60 hover:bg-white/[0.06] disabled:opacity-40 disabled:pointer-events-none ${className}`}
  >
    {children}
  </button>
);
